module.exports = __webpack_public_path__ + "static/img/erweim.553cb0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweim.jpg
// module id = C1K/
// module chunks = 0